import { getApiEndpoint } from "../utils/constants/api";
import { SHOP_SOURCES } from "../utils/constants/shopSources";
import { wfetch } from "../utils/fetch";
import { getCategories, getCategoryTreeIds } from "./categories.service";

// Reorder a category's products to match the merchandiser's saved sequence and interleave any
// authored banner ("Störer") tiles. The sequence is ordinal: listed products come first in that
// order, banners are inserted at their position, and products not listed keep their original order
// at the end. Banner markers carry `__banner` so the grid renders a promo tile instead of a product
// card; they have no category/price/variation fields, so the sort/filter utils skip them.
export const applyMerchandising = (products, items) => {
    if (!Array.isArray(items) || !Array.isArray(products)) return products;
    const byId = new Map(products.map((p) => [p["@id"], p]));
    const ordered = [];
    const used = new Set();
    let bannerSeq = 0;
    items.forEach((it) => {
        if (!it) return;
        if (it.kind === "banner") {
            ordered.push({ __banner: true, "@id": `__banner-${bannerSeq++}`, link: it.link || "", size: it.size || "regular" });
        } else if (it.kind === "product" && byId.has(it.productId)) {
            ordered.push(byId.get(it.productId));
            used.add(it.productId);
        }
    });
    products.forEach((p) => {
        if (!used.has(p["@id"])) ordered.push(p);
    });
    return ordered;
};

export const getProducts = async (opts) => {
    const { source, category, queryParams } = opts;

    // JCR source
    if (source === SHOP_SOURCES.JCR) {
        const { lang } = opts;

        const res = await wfetch(getApiEndpoint("PRODUCTS", { queryParams: { lang, ...queryParams } }));
        let products = res?.data?.results;

        if (!category) return products;

        const categoryIds = getCategoryTreeIds(category);

        return filterProductsByCategoryIds(products, categoryIds, source);
    }

    // External sources
    const res = await wfetch(
        getApiEndpoint("EXTERNAL_PRODUCTS", {
            pathParams: { source, categoryId: encodeURIComponent(category?.["@id"]) },
            queryParams: { limit: 1000, ...queryParams },
        }),
    );

    return res?.data?.results;
};

export const getProduct = async (opts) => {
    const { source, productId } = opts;

    // JCR source
    if (source === SHOP_SOURCES.JCR) {
        const { lang } = opts;
        const res = await wfetch(getApiEndpoint("PRODUCTS", { queryParams: { "@path": productId, lang } }));

        return res?.data?.results?.[0];
    }

    // External sources
    const res = await wfetch(getApiEndpoint("EXTERNAL_PRODUCT", { pathParams: { source, productId: encodeURIComponent(productId) } }));

    return res?.data;
};

export const filterProductsByCategoryIds = (products, categoryIds, source) => {
    if (source !== SHOP_SOURCES.JCR) return products;

    return products.filter((p) => Array.isArray(p.category) && p.category.some((c) => categoryIds.has(c["@id"])));
};
